import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UploadFile } from 'ng-zorro-antd';
import { FileModelUser } from '../../models/upload.model';
import { UtilsService } from '../../services/utils/utils.service';

@Component({
  selector: 'app-upload-user-modal',
  templateUrl: './upload-user-modal.component.html',
  styleUrls: ['./upload-user-modal.component.scss']
})
export class UploadUserModalComponent implements OnInit {

  @Input('isVisible') isVisible: boolean;
  @Input() fileList: UploadFile[];
  @Output() closeModal = new EventEmitter();

  total: number;
  overSize: boolean = false;
  correctFileType: boolean = true;

  constructor(
    public util : UtilsService
  ) { }

  ngOnInit() {
  }

  beforeUpload = (file: UploadFile): boolean => {
    let maxSize: number = 0
    if (this.fileList.length > 0) {
      this.fileList.forEach(element => {
        maxSize += element.size;
      });
    }
    maxSize += file.size
    if (maxSize > 10485760) {
      this.overSize = true;
      if (file.type === 'application/pdf') {
        this.correctFileType = true;
      } else {
        this.correctFileType = false;
      }
    } else {
      if (file.type === 'application/pdf') {
        this.correctFileType = true;
        this.fileList = this.fileList.concat(file);
      } else {
        this.correctFileType = false;
      }
      this.overSize = false;
    }
    return false;
  };

  afterClose(): void {
    this.overSize = false;
  }

  uploadFile(): void {
    if (this.fileList.length > 0) {
      let tmpArray = new Array<FileModelUser>();
      var genBase64 = new Promise((resolve, reject) => {
        this.fileList.forEach((value, index, array) => {
          let tmp = new FileModelUser();
          this.util.changeFile(value).then((base64: string): any => {
            tmp.file = base64.split(',')[1];
            tmp.fileName = value.name;
            tmp.fileSize = this.convertByteToMB(value.size.toString());
            tmp.fileData = value;
            tmpArray.push(tmp);
            if (index === array.length - 1) resolve();
          });
        });
      });
      genBase64.then(() => {
        this.closeModal.emit(tmpArray);
      });
    } else {
      let tmpArray: FileModelUser[] = [];
      this.closeModal.emit(tmpArray);
    }
  }

  convertByteToMB(val: string): number {
    let result = parseFloat(val) / 1048576;
    return result;
  }

  deleteUploadFile(index: any): void {
    this.fileList.splice(index, 1);
    this.overSize = false;
    this.correctFileType = true;
  }

}
